import { useState, useContext } from "react";
import { notify } from "../../utils/utils";
import { Fetch } from "../../services/api";
import { useModal } from '../useModal';
import { UserContext } from "../../context/provider/UserProvider";

const urlEntregable = process.env.REACT_APP_XPROJECT_API + "/Deliverable";

export const useEntregables = () => {
    const { stateUser } = useContext(UserContext);
    const entregableDefault = {
        nomEntregable: "",
        codTicket: 0,
        codUsuarioResponsable: 0,
        codUsuarioParticipanteConcatenado: "",
        fechaInicioProgramadoEntregable: '',
        horaInicioProgramadoEntregable: '',
        fechaFinProgramadoEntregable:'',
        horaFinProgramadoEntregable: '',
        codTicketEntregable: 0
    }
    

    const [ entregables, setEntregables ] = useState([])
    const [ entregable, setEntregable ] = useState(entregableDefault);
    const [ isOpenModalEntregable, openModalEntregable, closeModalEntregable ] = useModal(false);
    
    const listarEntregables = async (codTicket) => {
        const response = await Fetch({
            url: urlEntregable + '?' + new URLSearchParams({
                CodTicket: codTicket
            })
        });

        if (response.isValid){
            setEntregables(response.content);
        }else{
            notify(response.content)
        }
    }

    const guardarEntregable = async (codTicket) => {
        try{
            const esGuardar = entregable.codTicketEntregable === 0 || entregable.codTicketEntregable === undefined;
            const response = await Fetch({
                url: urlEntregable,
                method: esGuardar ? 'POST' : 'PUT', 
                body: JSON.stringify({
                    ...(
                        esGuardar ?
                            {
                                codTicket: parseInt(codTicket),
                            }
                            :
                            {
                                codTicketEntregable: parseInt(entregable.codTicketEntregable)
                            }
                        ),
                    codUsuarioResponsable: parseInt(entregable.codUsuarioResponsable),
                    codUsuarioAccion: parseInt(stateUser.codUsuario),
                    nomEntregable: entregable.nomEntregable,
                    codUsuarioParticipanteConcatenado: entregable.codUsuarioParticipanteConcatenado || "" ,
                    fechaInicioProgramado: entregable.fechaInicioProgramadoEntregable + ' ' + entregable.horaInicioProgramadoEntregable,
                    fechaFinProgramado: entregable.fechaFinProgramadoEntregable + ' ' + entregable.horaFinProgramadoEntregable,
                })
    
            });
            notify(response.isValid ? response.content : response.exceptions[0].description, (response.isValid ? 'success' : 'error'));
            return response.isValid
        }
        catch(error){
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al guardar: ',error);
            return false;
        }
    }  

    const editarValorEntregable = (key,value) =>{
        setEntregable(entregable => {
            return {
                ...entregable,
                [key]: value
            }
        });
    }

    const obtenerDetalleEntregable = async (codTicketEntregable) => {
        try{
            if(codTicketEntregable){
                const response  = await Fetch({
                    url: urlEntregable + '/detail?' + new URLSearchParams({
                        CodTicketEntregable: codTicketEntregable
                    })
                })
                if(response.isValid){
                    setEntregable(response.content[0]);
                }
            }
            else{
                setEntregable(entregableDefault);
            }

        }
        catch(error){
            setEntregable(entregableDefault);
            notify('Ocurrió un erro en el servicio', 'error');
            console.log('Error al listar detalle: ',error);
        }
    }

    const eliminarEntregable = async (codTicketEntregable) => {
        try{
            const response = await Fetch({
                url: urlEntregable,
                method: 'Delete',
                body: JSON.stringify({
                    codUsuarioAccion: stateUser.codUsuario,
                    codTicketEntregable: codTicketEntregable
                })
            })
            notify(response.isValid ? response.content : response.exceptions[0].description , response.isValid ? 'success': 'error')
            return response.isValid
        }
        catch(e){
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al eliminar entregable: ',e);
            return false;
        }
    }

    return{
        entregable,
        entregables,
        listarEntregables,
        editarValorEntregable,
        guardarEntregable,
        isOpenModalEntregable,
        openModalEntregable,
        closeModalEntregable,
        obtenerDetalleEntregable,
        eliminarEntregable,
    }
}